import { useTranslation } from "react-i18next";

import BaseDivider from "@/components_v2/Divider/BaseDivider";
import BaseSpinner from "@/components_v2/Spiner/BaseSpinner";
import {
  DataBlockContent,
  DataBlockDetails,
} from "@/domains/datablocks/components/DataBlockContent";
import { useGetDataTemplateByIdQuery } from "@/redux/service";

import type { EvidencePreviewPanelProps } from "../types";

import "../styles.css";

const EvidencePreviewPanel = ({ dataBlock }: EvidencePreviewPanelProps) => {
  const { t } = useTranslation();
  const {
    data: dataTemplate,
    isLoading,
    isError,
  } = useGetDataTemplateByIdQuery(dataBlock.template.id);

  if (isLoading) {
    return (
      <div className="flex justify-center full-width">
        <BaseSpinner size="small" />
      </div>
    );
  }

  if (isError) {
    return (
      <p className="body-m-regular">
        {t("survey.labels.evidencePreviewLoadError")}
      </p>
    );
  }

  return (
    <div className="flex flex-col gap-400">
      <DataBlockDetails dataBlock={dataBlock} dataTemplate={dataTemplate!} />

      <BaseDivider />

      <DataBlockContent dataBlock={dataBlock} dataTemplate={dataTemplate!} />
    </div>
  );
};

export default EvidencePreviewPanel;
